import { GuidService } from 'ui-components/services/guid-service';
import * as BulkUpdateActions from '../../../store/bulk/update/bulk.update.actions';
import { BulkActions } from '../../../enums/bulk-actions';

export const CustomField2 = {
  id: 'custom-field-2',
  name: BulkActions.customFieldTwo.message,

  makeHandler: (dispatch, bulkUpdateTypeData) => {
    return (ids, filters) =>
      dispatch(BulkUpdateActions.startBulkUpdateJob(bulkUpdateTypeData, [BulkActions.customFieldTwo], ids, GuidService.newGuid(), filters));
  },
};
